<template>
    <div class="el-table__table-wrapper">
        <div class="el-table__inner-main">
            <h2 class="el-form-card__inner-title mb-2">
                {{ $t('title.materialInStock') }}
            </h2>
            <el-table
                :data="availableItems"
                class="el-table__inner-editable el-table__inner-editable--no-top-margin"
                style="width: 100%"
                border
            >
                <el-table-column
                    :label="$t('table.column.packageID')"
                    prop="MylocPackageID"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.description')"
                    prop="MylocDescription"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.goodsMark')"
                    prop="MylocGoodsMark"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.supplier')"
                    prop="MylocSupplier"
                    width="90"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.type')"
                    prop="MylocPackageType"
                    width="70"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.length')"
                    prop="MylocPackageLength"
                    width="100"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.width')"
                    prop="MylocPackageWidth"
                    width="90"
                ></el-table-column>
                <el-table-column
                    :label="$t('table.column.grossWeight')"
                    prop="MylocGrossWeigth"
                    width="110"
                ></el-table-column>
                <el-table-column
                    class-name="el-col__action--green"
                    width="30"
                    align="center"
                    :resizable="false"
                >
                    <template slot-scope="{ row }">
                        <i class="material-icons" @click="() => addToOrder(row)"
                        >chevron_right</i
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="el-table__inner-side">
            <div class="el-table__inner-main">
                <h2 class="el-form-card__inner-title mb-2">
                    {{ $t('title.materialOnOrder') }}
                </h2>
                <el-table
                    :data="value"
                    class="el-table__inner-editable el-table__inner-editable--no-top-margin"
                    style="width: 100%"
                    border
                >
                    <el-table-column
                        :label="$t('table.column.packageID')"
                        prop="MylocPackageID"
                    ></el-table-column>
                    <el-table-column
                        :label="$t('table.column.description')"
                        prop="MylocDescription"
                    ></el-table-column>
                    <el-table-column
                        :label="$t('table.column.type')"
                        prop="MylocPackageType"
                        width="70"
                    ></el-table-column>
                    <el-table-column
                        class-name="el-col__action--red"
                        width="30"
                        align="center"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <i
                                class="material-icons"
                                @click="() => removeFromOrder(row)"
                            >delete</i
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
    name: 'MyLocInventory',

    props: ['items', 'value'],

    computed: {
        availableItems() {
            return this.items.filter(item => {
                return !this.value.includes(item)
            })
        },
    },

    methods: {
        forHuman(date) {
            return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)
        },

        addToOrder(item) {
            this.$emit('input', [...this.value, item])
        },

        removeFromOrder(item) {
            const items = this.value.filter(order => {
                return order.MylocPackageID !== item.MylocPackageID
            })

            this.$emit('input', items)
        },
    },
}
</script>

<style scoped>
</style>
